export default function ProductCards() {
  const products = [
    {
      id: 1,
      name: 'PlayStation 5',
      brand: 'Sony',
      description: 'Experimente o ápice da tecnologia com o PS5. Carregamentos instantâneos com o SSD de ultra velocidade e uma imersão profunda com gatilhos adaptáveis e áudio 3D. Temos versões com leitor de disco e a Digital Edition com entrega pronta para você levar hoje mesmo.',
      image: 'https://public.readdy.ai/ai/img_res/0663b4c5995c96e08bdd0c956591d17c.jpg',
      icon: 'ri-playstation-line',
      color: '#0047AB'
    },
    {
      id: 2,
      name: 'Xbox Series X | S',
      brand: 'Microsoft',
      description: 'A porta de entrada para a nova geração com o melhor custo-benefício. O Series S oferece desempenho digital incrível, enquanto o Series X entrega o poder do 4K nativo. Combine com o Xbox Game Pass e tenha acesso a centenas de jogos instantâneos.',
      image: 'https://readdy.ai/api/search-image?query=Microsoft%20Xbox%20Series%20X%20and%20Series%20S%20consoles%20side%20by%20side%20on%20clean%20minimalist%20dark%20background%20with%20green%20accent%20lighting%20professional%20product%20photography%20high%20quality%20studio%20shot%20modern%20gaming%20hardware&width=600&height=400&seq=xboxprod002&orientation=landscape',
      icon: 'ri-xbox-line',
      color: '#0047AB'
    },
    {
      id: 3,
      name: 'Nintendo Switch',
      brand: 'OLED/Padrão/Lite',
      description: 'A liberdade de jogar onde e como quiser. Seja no modo portátil ou na TV com a família, o Nintendo Switch é a casa dos clássicos como Mario, Zelda e Pokémon. Escolha entre a tela vibrante do modelo OLED, o equilíbrio do Standard ou a portabilidade do Lite.',
      image: 'https://readdy.ai/api/search-image?query=Nintendo%20Switch%20OLED%20console%20with%20Joy-Con%20controllers%20on%20clean%20minimalist%20dark%20background%20with%20red%20accent%20lighting%20professional%20product%20photography%20high%20quality%20studio%20shot%20portable%20gaming%20device&width=600&height=400&seq=switchprod003&orientation=landscape',
      icon: 'ri-switch-line',
      color: '#0047AB'
    },
    {
      id: 4,
      name: 'Jogos e Acessórios',
      brand: 'Completo Setup',
      description: 'Monte o seu setup completo na Gamer Station. Trabalhamos com os últimos lançamentos em mídia física, controles DualSense, headsets de alta performance e itens de decoração exclusivos para deixar seu canto gamer com sua cara.',
      image: 'https://readdy.ai/api/search-image?query=Gaming%20accessories%20collection%20including%20controllers%20headsets%20and%20game%20cases%20on%20clean%20minimalist%20dark%20background%20with%20blue%20accent%20lighting%20professional%20product%20photography%20high%20quality%20studio%20shot%20complete%20gaming%20setup&width=600&height=400&seq=accessprod004&orientation=landscape',
      icon: 'ri-gamepad-line',
      color: '#0047AB'
    }
  ];

  return (
    <section id="produtos" className="py-20 px-4 sm:px-6 lg:px-8 bg-black relative" data-product-shop>
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-[#0047AB] rounded-full blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto relative z-10">
        <div className="text-center mb-16">
          <h2 className="text-4xl sm:text-5xl font-bold text-white mb-4">
            Consoles e Games em <span className="text-[#0047AB]">São Paulo</span>
          </h2>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            O estoque mais completo da Santa Ifigênia com os melhores preços e garantia oficial
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {products.map((product, index) => (
            <div 
              key={product.id}
              className="group bg-gradient-to-br from-gray-900 to-black border border-[#0047AB]/30 rounded-2xl overflow-hidden hover:border-[#0047AB] transition-all duration-500 hover:shadow-2xl hover:shadow-[#0047AB]/30 hover:scale-[1.02]"
              style={{ animationDelay: `${index * 100}ms` }}
            >
              <div className="relative h-64 w-full overflow-hidden">
                <img 
                  src={product.image} 
                  alt={`Comprar ${product.name} Santa Ifigênia São Paulo`}
                  title={`${product.name} - Loja de Games Gamer Station`}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/50 to-transparent"></div>
                <div className="absolute top-4 right-4 w-14 h-14 bg-[#0047AB] rounded-full flex items-center justify-center shadow-lg">
                  <i className={`${product.icon} text-3xl text-white`}></i>
                </div>
              </div>

              <div className="p-6 space-y-4">
                <div>
                  <p className="text-[#0047AB] text-sm font-semibold mb-1">{product.brand}</p>
                  <h3 className="text-2xl font-bold text-white mb-3">{product.name}</h3>
                  <p className="text-gray-400 text-sm leading-relaxed">
                    {product.description}
                  </p>
                </div>

                <a 
                  href="https://wa.me/5511951063038" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="block w-full bg-[#0047AB] text-white px-6 py-3 rounded-lg hover:bg-[#003380] transition-all duration-300 text-center font-semibold cursor-pointer group-hover:shadow-lg group-hover:shadow-[#0047AB]/50 whitespace-nowrap"
                >
                  <i className="ri-whatsapp-line mr-2"></i>
                  Consultar Preço
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}